import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
`;

export const Title = styled.p`
    font-size: 20px;
    margin: 0;
    font-weight: 900;
    color: #232323;
    width: 100%;
    text-align: center;
    margin-top: 24px;
    margin-bottom: 16px;
`;

